var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("orphan.orphans_details") } },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "secondaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.rfrsh"),
              icon: "fa-light fa-rotate-right",
              variant: "light",
              "responsive-layout": true,
            },
            on: { click: _vm.getOrphan },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _vm.activateSpinner
            ? _c("spinner")
            : _vm.Orphan
            ? [
                _c(
                  "div",
                  [
                    _c(
                      "form-accordion",
                      {
                        staticClass: "p-3 mb-5",
                        attrs: {
                          title: _vm.$t("orphan.details"),
                          isTitleUpperCase: false,
                        },
                      },
                      [
                        _c(
                          "b-row",
                          { staticClass: "form-group" },
                          [
                            _vm.Orphan.Type !== ""
                              ? _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t("orphan.type"),
                                        inputValue: _vm.Orphan.Type,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.Orphan.Reference !== ""
                              ? _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t("orphan.reference"),
                                        inputValue: _vm.Orphan.Reference,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.Orphan.CreationDate !== ""
                              ? _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t(
                                          "orphan.creation_date"
                                        ),
                                        inputValue: _vm.getDateDay(
                                          _vm.Orphan.CreationDate
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.Orphan.CreationDate === "" ||
                            _vm.Orphan.Reference === "" ||
                            _vm.Orphan.CreationDate === ""
                              ? _c("b-col", {
                                  staticClass: "mb-5",
                                  attrs: { sm: "4" },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "form-group" },
                          [
                            _vm.Orphan.IdScore != ""
                              ? _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t("orphan.id_score"),
                                        inputValue: _vm.Orphan.IdScore,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.Orphan.NameScore != ""
                              ? _c(
                                  "b-col",
                                  { staticClass: "mb-5", attrs: { sm: "4" } },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t("orphan.name_score"),
                                        inputValue: _vm.Orphan.NameScore,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { staticClass: "mb-5", attrs: { sm: "4" } },
                              [
                                _vm.Orphan.FirstName != "" &&
                                _vm.Orphan.LastName != "" &&
                                _vm.type == "DDV"
                                  ? _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t("orphan.name"),
                                        inputValue:
                                          _vm.Orphan.FirstName +
                                          " " +
                                          _vm.Orphan.LastName,
                                      },
                                    })
                                  : _c("form-read-group-label-input", {
                                      attrs: {
                                        inputLabel: _vm.$t("orphan.name"),
                                        inputValue: _vm.Orphan.CompanyName,
                                      },
                                    }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.Orphan.IdScore == "" ||
                            _vm.Orphan.NameScore == ""
                              ? _c("b-col", {
                                  staticClass: "mb-5",
                                  attrs: { sm: "4" },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr", { staticClass: "mx-auto" }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }